<template>
  <div class="inputer-check">
    <input type="checkbox" @change="change" :checked="value" :disabled="disabled" />
    <div v-if="changed" class="changed" title="Neuložená změna">
      <i class="fa fa-wrench" />
    </div>
  </div>
</template>

<script>
export default {
  name: "inputer-check",
  props: {
    paths: {},
    disabled: { default: false }
  },
  computed: {
    value() {
      return this.$store.getters.getAt(this.paths);
    },
    changed() {
      return this.$store.getters.isChangedAt(this.paths);
    }
  },
  methods: {
    change() {
      this.$store.commit("update", {
        paths: this.paths,
        value: !this.value
      });
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

.inputer-check
  display: flex
  .changed
    color: $c-warning
  input
    @include inputer-check()
    &[disabled]
      cursor: not-allowed
</style>
